import React from 'react';
import './MenuPopupDelivery.scss';
import './MenuPopupDelivery-media.scss';
import { DeliveryList } from './constants';
import MenuPopupDeliveryAdd from '../MenuPopupDeliveryAdd/MenuPopupDeliveryAdd';
import { ClosedSubMenuComponent } from '../../../services/GlobalFunctions';
import LinkHashMenu from '../LinkHashMenu/LinkHashMenu';
import LinkMenu from '../LinkMenu/LinkMenu';
import {IMenu} from "../../../redux/initState/InterfacesState";
import clsx from "clsx";

export interface Props {
  onClickLink: any;
  showServices?: boolean;
  showDelivery?: boolean;
  servicesData?: any;
  geographyData?: any;
}

const MenuPopupDelivery = ({ onClickLink, showServices = true, showDelivery = true, servicesData, geographyData }: Props) => {
  const menus: IMenu[][] = [];

  // Convert children array to menu format - only use first column
  const convertToMenuFormat = (data: any): IMenu[] => {
    if (!data || !data.children || data.children.length === 0) return [];

    // Take first column from children array
    const firstColumn = data.children[0];
    if (!Array.isArray(firstColumn)) return [];

    return firstColumn
      .filter((item: any) => item && item.title && item.url)
      .map((item: any) => ({
        text: item.title,
        link: item.url,
        hash: false
      }));
  };

  if (showServices) {
    if (servicesData) {
      const servicesMenu = convertToMenuFormat(servicesData);
      if (servicesMenu.length > 0) {
        menus.push(servicesMenu);
      } else {
        // Fallback to hardcoded if data is empty
        menus.push(DeliveryList[0]);
      }
    } else {
      // Fallback to hardcoded
      menus.push(DeliveryList[0]);
    }
  }

  if (showDelivery) {
    if (geographyData) {
      const geographyMenu = convertToMenuFormat(geographyData);
      if (geographyMenu.length > 0) {
        menus.push(geographyMenu);
      } else {
        // Fallback to hardcoded if data is empty
        menus.push(DeliveryList[1]);
      }
    } else {
      // Fallback to hardcoded
      menus.push(DeliveryList[1]);
    }
  }
  return (
    <div className="menu-popup-delivery">
      <div className={clsx("menu-popup-delivery__content", {'two_columns': menus.length === 1, 'three_columns': menus.length === 2})}>
        {menus.map((list, i) => (
          <div className="menu-popup-delivery__column" key={i}>
            {list.map((menu, idx) =>
              menu.link.length ? (
                <div className="menu-popup-delivery__link" onClick={ClosedSubMenuComponent} key={idx}>
                  {menu.hash ? (
                    <LinkHashMenu menu={menu} onClickLink={onClickLink} />
                  ) : (
                    <LinkMenu menu={menu} onClickLink={onClickLink} />
                  )}
                </div>
              ) : (
                <p key={idx}>{menu.text}</p>
              )
            )}
          </div>
        ))}

        <MenuPopupDeliveryAdd addMenuData={servicesData || geographyData} />
      </div>
    </div>
  );
};

export default MenuPopupDelivery;
